export default __webpack_public_path__ + "static/media/down-collapse-white.d6b88db0.svg";